import { motion } from "framer-motion";

export function SectionLabel({ children, className = "" }) {
  return (
    <p className={`tok-eyebrow ${className}`}>
      {children}
    </p>
  );
}

export function SectionHeading({ children, className = "" }) {
  return (
    <h2 className={`tok-headline-xl ${className}`}>
      {children}
    </h2>
  );
}

export function Container({ children, className = "" }) {
  return (
    <div className={`max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 ${className}`}>
      {children}
    </div>
  );
}

/**
 * Subtle cinematic transition between major page sections.
 * Renders as a sliver containing a slow ambient gradient, a small
 * letter-spaced marker word, and a thin scaling gold rule on scroll-in.
 */
export function SectionDivider({ label = "•", className = "" }) {
  return (
    <div
      aria-hidden
      className={`relative py-14 sm:py-20 overflow-hidden ${className}`}
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-400/25 to-transparent" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,193,7,0.05)_0%,transparent_60%)]" />
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.6 }}
        transition={{ duration: 1, ease: "easeOut" }}
        className="relative flex items-center justify-center gap-5"
      >
        <motion.span
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 1.4, ease: "easeOut" }}
          className="origin-right block h-px w-24 sm:w-40 bg-amber-400/50"
        />
        <span className="text-[10px] uppercase tracking-[0.5em] text-amber-400/70 font-bold">
          {label}
        </span>
        <motion.span
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 1.4, ease: "easeOut" }}
          className="origin-left block h-px w-24 sm:w-40 bg-amber-400/50"
        />
      </motion.div>
    </div>
  );
}

export function FadeIn({ children, delay = 0, y = 24, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, delay, ease: "easeOut" }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
